<div class="modal__content">
  <div class="confirmation-popup-header">
    <i class="fas fa-list-check"></i>SUBMISSION RULES
  </div>

  <div class="confirmation-popup-text">
    <p>
      Please check and/or resolve the issues below.
      Items in <span class="hard-stop fw-bold">Red</span> must be fixed before the spread can be completed,
      whereas items in <span class="soft-stop fw-bold">Yellow</span> do not have to be fixed but should be checked.
    </p>
    <div class="validation-results">
      @for (statementType of groupedResults; track statementType) {
        <div class="statement-type-section">
          <div class="statement-type-title">{{ getStatementDisplayName(statementType.statement) }}</div>
          <div class="row">
            @for (period of statementType.periods; track period) {
              <div class="col-md-12">
                <div class="text-left text-muted mb-2">{{ period.statementDate }}</div>
                @if (period.status === 'passing') {
                  <div class="result-block success-block"
                    (click)="onValidationRuleClick(statementType.statement.id, period.statementDate, period.periodKeyUuid)"
                    title="Click to navigate to this period">
                    <i class="fas fa-circle-check me-2"></i>
                    <div class="flex-grow-1">
                      <div class="fw-bold">Passing</div>
                      <div class="small">All rules passing for this period</div>
                    </div>
                    <i class="fas fa-chevron-right success-block"></i>
                  </div>
                } @else {
                  @for (rule of period.rules; track rule) {
                    <div class="result-block"
                      [ngClass]="rule.action === SubmissionRuleActions.HARD_STOP ? 'error-block' : 'warning-block'"
                      (click)="onValidationRuleClick(statementType.statement.id, period.statementDate, period.periodKeyUuid, rule.rowRef)"
                      title="Click to navigate to this validation issue">
                      <i [class]="getStatusIcon(rule.action)" class="me-2"></i>
                      <div class="flex-grow-1">
                        <div class="fw-bold">{{ getRowDisplayText(rule) }}</div>
                        <div class="small">{{ rule.message }}</div>
                      </div>
                      <i class="fas fa-chevron-right" [ngClass]="rule.action === SubmissionRuleActions.HARD_STOP ? 'error-block' : 'warning-block'"></i>
                    </div>
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="modal__footer align-right">
  @if (hasHardStops) {
    <button
      class="btn btn-primary"
      (click)="onClose()">
      Ok
    </button>
  }
  @if (!hasHardStops && hasSoftStops) {
    <button
      class="btn btn-secondary me-2"
      (click)="onClose()">
      Cancel
    </button>
    <button
      class="btn btn-primary"
      (click)="onProceed()">
      Complete Spread
    </button>
  }
</div>